/* eslint-disable */

const freeNode = {x: 'free', ry: 'free', z: 'free'};
const fixedNode = {x: 'fixed', ry: 'free', z: 'fixed'};

export function getPurlinModel(lenLeft, lensMid, lenRight, purlinLen, heightColumn, cathetusStrut, supports, hasStruts, xHinges) {
    const nodes = [];
    const members = [];
    const dims = [];
    let points = [];

    const hasColumns = supports.includes('column');

    let zPurlin = 0;

    if (hasColumns) {
        zPurlin = heightColumn;
    }

    // Sort hinges in increasing order
    xHinges.sort((a, b) => +a - +b);

    [0, ...xHinges, purlinLen].forEach((x, i) => {
        nodes.push({
            'label': `N${i + 1}`,
            'coords': [+x, 0, zPurlin],
            'fixity': freeNode
        });
        points.push([+x, 0, zPurlin+0.7]);
    })

    dims.push({
        points: points,
        extrude: 1.2,
    });

    for (let i = 0; i < nodes.length - 1; i++) {
        let hinges = [true, false];
        if (i === 0) {
            hinges = [false, false];
        }
        members.push({
            'label': `E${i + 1}`,
            'start_node': `N${i + 1}`,
            'end_node': `N${i + 2}`,
            'hinges': hinges
        });
    }

    // Create an array starting with x-coord of first support
    const xCoords = [+lenLeft];
    // Add the cumulative sums from lensMid to the array
    for (let i = 0; i < lensMid.length; i++) {
        xCoords.push(xCoords[xCoords.length - 1] + +lensMid[i]);
    }

    points = [[0, 0, zPurlin]];

    xCoords.forEach((x, i) => {
        const support = supports[i];
        nodes.push({
            'label': `N${nodes.length + 1}`,
            'coords': [x, 0, zPurlin],
            'fixity': support === 'wall' ? fixedNode : freeNode
        });
        points.push([x, 0, zPurlin]);
    })

    points.push([purlinLen, 0, zPurlin]);

    dims.push({
        points: points,
        extrude: 1,
    });

    if (hasColumns) {
        supports.forEach((support, i) => {
            if (support === 'column') {
                nodes.push({
                    'label': `N${nodes.length + 1}`,
                    'coords': [xCoords[i], 0, 0],
                    'fixity': fixedNode
                });
                members.push({
                    'label': `E${members.length + 1}`,
                    'start_node': `N${i + 3 + xHinges.length}`,
                    'end_node': `N${nodes.length}`,
                    'hinges': [true, false]
                });

                const extrude = hasStruts ? +cathetusStrut + 1 : 1;
                dims.push({
                    points: [[xCoords[i], 0, 0], [xCoords[i], 0, zPurlin]],
                    extrude: extrude,
                })

                if (hasStruts) {
                    let isCreated = false;

                    points = [];

                    nodes.push({
                        'label': `N${nodes.length + 1}`,
                        'coords': [xCoords[i], 0, zPurlin - +cathetusStrut],
                        'fixity': freeNode
                    });

                    if (!(i === 0 && +cathetusStrut > +lenLeft)) {
                        nodes.push({
                            'label': `N${nodes.length + 1}`,
                            'coords': [xCoords[i] - +cathetusStrut, 0, zPurlin],
                            'fixity': freeNode
                        });
                        members.push({
                            'label': `E${members.length + 1}`,
                            'start_node': `N${nodes.length - 1}`,
                            'end_node': `N${nodes.length}`,
                            'hinges': [true, true]
                        });
                        points.push([xCoords[i] - +cathetusStrut, 0, zPurlin - +cathetusStrut]);
                        isCreated = true;
                    }

                    points.push([xCoords[i], 0, zPurlin - +cathetusStrut]);

                    if (!(i === supports.length - 1 && +cathetusStrut > +lenRight)) {
                        nodes.push({
                            'label': `N${nodes.length + 1}`,
                            'coords': [xCoords[i] + +cathetusStrut, 0, zPurlin],
                            'fixity': freeNode
                        });

                        let index = isCreated ? nodes.length - 2 : nodes.length - 1;

                        members.push({
                            'label': `E${members.length + 1}`,
                            'start_node': `N${index}`,
                            'end_node': `N${nodes.length}`,
                            'hinges': [true, true]
                        });
                        points.push([xCoords[i] + +cathetusStrut, 0, zPurlin - +cathetusStrut])
                    }


                    dims.push({
                        points: [[xCoords[i] - +cathetusStrut, 0, zPurlin - +cathetusStrut], [xCoords[i] - +cathetusStrut, 0, zPurlin]],
                        extrude: 0.5,
                    });
                    dims.push({
                        points: points,
                        extrude: -1,
                    })
                }
            }
        });
    }

    return {
        nodes: nodes,
        members: members,
        dims: dims,
    };
}